import {
  Settings,
  Mail,
  Upload,
  Home,
  FileText,
  Image,
  FolderKanban,
  HelpCircle,
  Globe,
  Share2,
  Database,
  ListTree,
  PanelsTopLeft,
  Building2,
  Milestone,
  User,
  Helicopter,
} from "lucide-react";

const menuData = [
  {
    label: "Dashboard",
    icon: Home,
    path: "/dashboard",
  },
  {
    label: "Menu",
    icon: ListTree,
    path: "/menu",
  },

  {
    label: "CMS",
    icon: FileText,
    path: "/cms",
  },
  {
    label: "Page Builder",
    icon: PanelsTopLeft,
    path: "/page-builder",
  },
  {
    label: "Home Banners",
    icon: Image,
    path: "/home-banners",
  },
  {
    label: "Page Banners",
    icon: Image,
    path: "/page-banners",
  },
  {
    label: "Projects",
    icon: FolderKanban,
    path: "/projects",
  },
  {
    label: "Category",
    icon: FolderKanban,
    path: "/category",
  },
  {
    label: "Master Tables",
    icon: Database,
    id: "uiBasic",
    subMenu: [
      // {
      //   label: "Brands", 
      //   icon: Building2,
      //   path: "/brands",
      // },
      {
        label: "Client Type",
        icon: Building2,
        path: "/client-type",
      },
      {
        label: "Milestones",
        icon: Milestone,
        path: "/milestones",
      },
      {
        label: "Teams",
        icon: User,
        path: "teams",
      },
      {
        label: "Services",
        icon: Helicopter,
        path: "/services",
      },
      {
        label: "FAQs",
        icon: HelpCircle,
        path: "/faqs",
      },
      {
        label: "PageWiseFAQ",
        icon: HelpCircle,
        path: "/pagewise-faq",
      },
      {
        label: "Testimonial",
        icon: HelpCircle,
        path: "/testimonials",
      },
      {
        label: "AMCPlan",
        icon: HelpCircle,
        path: "/amc-plans",
      },
      {
        label: "Module",
        icon: HelpCircle,
        path: "/modules",
      },
      {
        label: "Feature",
        icon: HelpCircle,
        path: "/features",
      }
    ],
  },

  {
    label: "Upload File",
    icon: Upload,
    path: "/upload-file",
  },

  {
    label: "Social Media",
    icon: Share2,
    path: "/social-media",
  },
  {
    label: "Contact Inquiries",
    icon: Mail,
    path: "/inquiries",
  },
  {
    label: "Settings",
    icon: Settings,
    id: "settings",
    subMenu: [
      {
        label: "Email Configuration",
        icon: Mail,
        path: "/email-configuration",
      },
      {
        label: "Email Templates",
        icon: FileText,
        path: "/email-template",
      },
      {
        label: "Website Settings",
        icon: Globe,
        path: "/website-setting",
      },
      {
        label: "Sitemap",
        icon: Globe,
        path: "/sitemap",
      },
      {
        label: "Seo Setting",
        icon: Globe,
        path: "/seo",
      },
    ],
  },
];

export default menuData;
